export const ENVS = {
	PRODUCTION: 'production',
	STAGING: 'staging',
	DEV: 'development',
	PROD: 'prod', // to deprecate for 'production'
	LOCAL: 'local', // to deprecate for 'development'
};

export const ENDPOINTS = {
	USERS: `${process.env.VUE_APP_SWATWAM_API_ENDPOINT}/v1/users`,
	WORKFLOWS: `${process.env.VUE_APP_CUSTOMER_API_ENDPOINT}/v4/customers`,
	INTERCOM_HASH: '/integrations/v1/intercom/sign-email',
};

export const ERRORS = {
	INVALID_HASH: 'The user hash received is invalid.',
};
